import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

// Notification messages for different status changes
const getNotificationMessage = (status, customerName = 'Customer') => {
  switch (status) {
    case 'picked':
      return {
        title: '🚚 Order Picked Up!',
        body: `Hi ${customerName}, your order has been picked up and is on its way to you!`
      };
    case 'delivered':
      return {
        title: '✅ Order Delivered!',
        body: `Hi ${customerName}, your order has been successfully delivered. Enjoy your meal!`
      };
    case 'skipped':
      return {
        title: '⚠️ Delivery Skipped',
        body: `Hi ${customerName}, your delivery was skipped today. Please contact support if this was unexpected.`
      };
    default:
      return {
        title: '📦 Delivery Update',
        body: `Hi ${customerName}, your delivery status has been updated.`
      };
  }
};

// Send notification to specific user
export const sendDeliveryNotification = async (userId, status, customerName) => {
  try {
    const message = getNotificationMessage(status, customerName);
    
    // Call your existing FCM function
    const response = await fetch('https://us-central1-jrhomefoods.cloudfunctions.net/sendNotification', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: message.title,
        body: message.body,
        type: 'delivery_update',
        userId: userId // You can modify your FCM function to send to specific user
      })
    });

    if (!response.ok) {
      throw new Error('Failed to send notification');
    }

    console.log('✅ Delivery notification sent successfully');
    return true;
  } catch (error) {
    console.error('❌ Error sending delivery notification:', error);
    return false;
  }
};

// Enhanced delivery status update with notification
export const updateDeliveryStatusWithNotification = async (deliveryId, newStatus, customerName, userId) => {
  try {
    // Update delivery status
    await updateDoc(doc(db, "deliveries", deliveryId), {
      status: newStatus,
      updatedAt: serverTimestamp()
    });

    // Send notification for status changes that matter to customer
    if (['picked', 'delivered', 'skipped'].includes(newStatus)) {
      await sendDeliveryNotification(userId, newStatus, customerName);
    }

    console.log('✅ Delivery status updated with notification');
    return true;
  } catch (error) {
    console.error('❌ Error updating delivery status:', error);
    return false;
  }
}; 